module.exports = __webpack_public_path__ + "static/img/profile.0488415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/other/profile.jpg
// module id = HcVe
// module chunks = 5